<script lang="ts">

import type ChartStep from './ChartStep';
import { CHART_COLORS } from './ChartLayer';
import type { ChartColor } from './ChartLayer';

/**
 * VChartStepLine — декларативный слой ступенчатой линии VChart. Сам ничего не рендерит.
 *
 * Ступени, у которых конец одной совпадает с началом следующей, соединяются вертикалью;
 * между несмежными ступенями — разрыв.
 *
 * @example
 * <VChartStepLine label="Бюджетная цена" color="red" dashed fill :steps="budgetSteps"/>
 */
export default defineComponent({
  name: 'VChartStepLine',

  props: {
    /** Подпись в легенде */
    label: {
      type:     String,
      required: true,
    },

    color: {
      type:      String as PropType<ChartColor>,
      required:  true,
      validator: (v: string) => (CHART_COLORS as readonly string[]).includes(v),
    },

    steps: {
      type:     Array as PropType<ChartStep[]>,
      required: true,
    },

    /** Пунктир — для справочной линии, которая не должна спорить с данными */
    dashed: {
      type:    Boolean,
      default: false,
    },

    /** Залить зону под линией до низа графика — например, «ниже бюджета» */
    fill: {
      type:    Boolean,
      default: false,
    },
  },

  render() {
    return null;
  },
});
</script>
